import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DemographicTripleComparisionDetail from './DemographicTripleComparisionDetail';

class DemographicsTripleComparisionPersona extends Component {
  constructor(props) {
    super(props);
    this.state = { demographicsList: [] };
  }

  render() {
    const demographicsList = [];
    if (this.props.demographics !== undefined) {
      _.each(this.props.demographics, demographic => {
        demographicsList.push({
          demographicsInfo: demographic,
          detailsGroupsList: demographic.detailGroups,
        });
      });
    }

    return (
      <div className="row fullwidth demoCardPdf">
        <div className="row fullwidth demographic-detail-columns demographicsTriplePersonaPdf">
          {!_.isEmpty(demographicsList) &&
            demographicsList.length > 0 &&
            demographicsList.map((demographic, index) => (
              <div key={index}>
                <div className="columns large-4 medium-4 small-4 pdf-triple-demographic-detail-columns">
                  {demographic.detailsGroupsList.map((demoDetail, i) => (
                    <div
                      className="row fullwidth demographic-detail-columns"
                      key={`demo-t${index}${i}`}
                    >
                      <div
                        className="columns large-12 small-12 medium-12"
                        id="demographicsRowLenghtPdf"
                      >
                        {
                          <DemographicTripleComparisionDetail
                            key={demoDetail.name}
                            demoDetail={demoDetail}
                            personaIndex={index}
                            selectedTab={this.props.selectedTab}
                          />
                        }
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

DemographicsTripleComparisionPersona.propTypes = {
  demographics: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.string,
};

function mapStateToProps() {
  return {
    // demographics: state.insight360.demographics
  };
}

function mapDispatchToProps() {
  return {
    // brand360Actions: bindActionCreators(brand360Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DemographicsTripleComparisionPersona);
